module.exports = __webpack_public_path__ + "img/color1.a9bb4c08.jpg";